<template>
	<form
		method="POST"
		@submit.prevent
		class="form"
	>
		<label>
			Email
			<br>
			<input class="form-control" type="email" v-model="form.email">
		</label>

		<label v-if="orders.length > 0">
			Ordine (seleziona)
			<br>
			<select class="form-control" v-model="form.selectedOrderId">
				<option value="NoOrder">Seleziona il tuo ordine</option>
				<option v-for="(order, index) in orders" :key="index" :value="order.id">Ordine n°: #{{order.id}} - Consegnato il {{order.delivery}}</option>
			</select>
		</label>	

		<label class="message">
			Oggetto <span v-if="subjects.length > 1">(scegli tra le opzioni)</span>
			<br>

			<div v-if="subjects.length <= 1" class='fake-select'>
				{{ subjects[0].name }}
			</div>
			<select class="form-control" v-model="selectedSubjectId" v-if="subjects.length > 1">
				<option
					v-for="(subject, index) in subjects"
					:key="index"
					:value="subject.id"
				>
					{{ subject.name }}
				</option>
			</select>
		</label>
		<label class="message">
			Messaggio
			<br>
			<textarea
				class="form-control" rows="5" v-model="form.message"
				placeholder="Scrivici il motivo del tuo contatto">
			</textarea>
		</label>

		<span v-if="subjects.find(r => r.id === selectedSubjectId).attachReq">
			{{ selectedSubjectId === 23 
				? 'Allega la foto dell\'etichetta di spedizione'
				: 'Allega la foto del prodotto ricevuto dannegiato/errato'
			}}
			<span class="red-text">*</span>
		</span>
		<span v-else>
			Allega eventuali file
		</span>

		<div class="flex-vcenter wrap group">
			<div>
				<div
					v-for="i in 5"
					v-if="(form.file.length >= i - 1)"
					:key="i"
				>
					<form @reset="deleteAtachment(i)">
						<input
							type='file'
							@change="attachment($event.target.files[0], i)"
							accept="image/*,.pdf"
							capture="camera"
						/>
						<button type="reset" class="red-cross" v-if="fileSelected(i)">x</button>
					</form>
				</div>
			</div>

			<CTA
				isWithLoader
				:content="`Invia`"
				@click="send()"
				:disabled="updating"
			/>
		</div>

		<flash :flash="flash" :state="state" />
	</form>
</template>

<script>
import Vue from 'vue'
import Flash from './Parts/Flash'
import { container } from '../services/container'
import { errorStore } from '../store/errorStore'
import { UserApi } from '../api/UserApi'

const moment = require('moment')

export default {
	data () {
		return {
			form: {
				email: this.user && this.user.email ? this.user.email : '',
				message: '',
				file: [],
				selectedOrderId: 'NoOrder'
			},

			flash: null,
			state: null,

			updating: false,

			selectedSubjectId: this.subjects[0].id,

			page: 1,
			show: 2,
			orders: [],
		}
	},

	components: {
		Flash
	},

	props: {
		user: {
			type: Object,
			default () {
				return null
			}
		},
		type: {
			type: String,
			default: null
		},
		sectionName: {
			type: String,
			default: null
		},
		subjects: {
			type: Array,
			default () {
				return null
			}
		}
	},

	methods: {
		alert() {
			alert()
		},
		send () {
			this.updating = true
			this.flash = ''

			this.call()

			.then(response => {
				this.$emit('success')

				this.updating = false
			})

			.catch(response => {
				this.flash = errorStore.format(response)
				this.state = 'error'

				this.updating = false
			})
		},

		call () {
			if (!this.form.message) {
				return Promise.reject(new Error('missing message'))
			}

			if (this.subjects.find(r => r.id === this.selectedSubjectId).attachReq && this.form.file.length < 1) {
				return Promise.reject(new Error('missing attachment'))
			}			

			var domain = container.get('freshdesk_domain')
			var key = container.get('freshdesk_key')

			var formdata = new FormData()

			formdata.append('description', this.form.message)
			formdata.append('email', this.form.email)
			
			formdata.append('subject', this.form.selectedOrderId + ' - ' + this.subjects.find(r => r.id === this.selectedSubjectId).name)
			if (this.subjects.find(r => r.id === this.selectedSubjectId).type) {
				formdata.append('type', this.subjects.find(r => r.id === this.selectedSubjectId).type)
			}
			formdata.append('priority', '1')
			formdata.append('status', '2')
			if (this.form.file.length > 0) {	
				this.form.file.forEach(r => formdata.append('attachments[]', r.src))
			}

			return Vue.http.post('https://' + domain + '.freshdesk.com/api/v2/tickets', formdata, { headers: {
				Authorization: 'Basic ' + btoa(key + ':x'),
				'Content-Type': 'multipart/form-data'
			}})
		},

		fileSelected(i) {
			return this.form.file.find(r => r.id === i)
		},

		deleteAtachment (i) {
			if (this.form.file.find(r => r.id === i)) {
				var index = this.form.file.findIndex(r => r.id === i)
				this.form.file.splice(index, 1)
			}
		},

		attachment (file, i) {
			if (file) {
				var fileMod = { src: file, id: i }
				this.deleteAtachment(i)
				this.form.file.push(fileMod)
			}

			else {
				this.deleteAtachment(i)
			}
		},

		loadOrders () {
			var um = new UserApi()
			um.orders({
				page: this.page,
				show: this.show,
				sort: '-created_at',
				query: 'processed eq 1'
			}).then(response => {
				this.orders = response.body.resources.map(resource => {
					const deliveryDate = moment(resource.date.delivery).locale('it').format('LL')
					return {id: resource.id, delivery: deliveryDate}
				})
			})
		}
	},
	mounted() {
		this.loadOrders()
	}
}

</script>

<style scoped>
.form {
	flex-wrap: wrap;
	text-align: left;
	background-color: #ededed;
	border-radius: 4px;
	padding: 10px;
}

.form label {
	flex-basis: 50%;
}

select,
select:focus,
select[disabled] {
	background-color: white;
}

select[disabled] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.fake-select {
	background-color: white;
	padding: 6px 15px;
}

.group .btn {
	margin-left: auto;
}

.group form {
	display: flex;
}

.group form input {
	max-width: 300px;
}

label {
	display: block;
}

label.message {
	flex-basis: 100%;
}

::placeholder {
    color: silver;
    opacity: 1;
}

:-ms-input-placeholder,
::-ms-input-placeholder {
    color: silver;
}

@media (max-width: 600px) {
	.form label {
		flex-basis: 100%;
	}

	.group .btn {
		margin-left: 0;
		flex-basis: 100%;
		margin-top: 10px;
		padding: 10px 0;
	}
}
</style>
